(function () {
  'use strict';

  function getVideos(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.rabitat-product-features-hyde__video'));
  }

  function getRows(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-hyde-feature-row]'));
  }

  function prepareVideo(video) {
    if (!video || video.tagName !== 'VIDEO') return;

    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    if (!video.getAttribute('preload')) {
      video.preload = 'none';
    }
  }

  function waitForVideoData(video) {
    if (video.readyState >= 2) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      video.addEventListener('loadeddata', resolve, { once: true });
      video.addEventListener('error', resolve, { once: true });
    });
  }

  function ensureVideoSource(video) {
    if (!video || video.dataset.hydeVideoLoaded === 'true') {
      return waitForVideoData(video);
    }

    var deferredSrc = video.dataset.hydeVideoSrc;
    if (deferredSrc) {
      var source = video.querySelector('source');
      if (!source) {
        source = document.createElement('source');
        source.type = 'video/mp4';
        video.appendChild(source);
      }
      source.src = deferredSrc;
      video.dataset.hydeVideoLoaded = 'true';
      video.load();
      return waitForVideoData(video);
    }

    if (video.querySelector('source[src]') || video.currentSrc || video.src) {
      video.dataset.hydeVideoLoaded = 'true';
      if (video.readyState < 1) {
        video.load();
      }
      return waitForVideoData(video);
    }

    return Promise.resolve();
  }

  function updateToggleState(video, isPlaying) {
    var media = video.closest('[data-hyde-video-media]');
    if (!media) return;

    var toggle = media.querySelector('[data-hyde-video-toggle]');
    var playIcon = media.querySelector('.rabitat-product-features-hyde__video-toggle-icon--play');
    var pauseIcon = media.querySelector('.rabitat-product-features-hyde__video-toggle-icon--pause');

    media.classList.toggle('is-playing', isPlaying);
    media.classList.toggle('is-paused', !isPlaying);

    if (toggle) {
      toggle.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    }

    if (playIcon) playIcon.hidden = isPlaying;
    if (pauseIcon) pauseIcon.hidden = !isPlaying;
  }

  function pauseVideo(video) {
    if (!video) return;
    video.pause();
    updateToggleState(video, false);
  }

  function playVideo(video) {
    if (!video) return Promise.resolve();

    prepareVideo(video);

    return ensureVideoSource(video).then(function () {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        return playPromise
          .then(function () {
            updateToggleState(video, true);
          })
          .catch(function () {
            updateToggleState(video, false);
          });
      }

      updateToggleState(video, !video.paused);
      return Promise.resolve();
    });
  }

  function getRowVisibilityRatio(row, viewport) {
    var rowRect = row.getBoundingClientRect();
    if (rowRect.width <= 0 || rowRect.height <= 0) return 0;

    var bounds = viewport
      ? viewport.getBoundingClientRect()
      : {
          top: 0,
          left: 0,
          right: window.innerWidth || document.documentElement.clientWidth,
          bottom: window.innerHeight || document.documentElement.clientHeight,
        };

    var overlapWidth = Math.min(rowRect.right, bounds.right) - Math.max(rowRect.left, bounds.left);
    var overlapHeight = Math.min(rowRect.bottom, bounds.bottom) - Math.max(rowRect.top, bounds.top);

    if (overlapWidth <= 0 || overlapHeight <= 0) return 0;

    return (overlapWidth * overlapHeight) / (rowRect.width * rowRect.height);
  }

  function getActiveRow(root) {
    var viewport = root.querySelector('[data-collection-viewport]');
    var rows = getRows(root);
    var bestRow = null;
    var bestRatio = 0;

    rows.forEach(function (row) {
      var ratio = getRowVisibilityRatio(row, viewport);
      if (ratio > bestRatio) {
        bestRatio = ratio;
        bestRow = row;
      }
    });

    return bestRatio >= 0.35 ? bestRow : null;
  }

  function preloadAdjacentVideo(root, activeRow) {
    if (!activeRow) return;

    var rows = getRows(root);
    var activeIndex = rows.indexOf(activeRow);
    if (activeIndex < 0) return;

    var nextRow = rows[activeIndex + 1];
    if (!nextRow) return;

    var nextVideo = nextRow.querySelector('.rabitat-product-features-hyde__video');
    if (!nextVideo || nextVideo.dataset.hydeVideoLoaded === 'true') return;

    ensureVideoSource(nextVideo);
  }

  function isMobileView() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function getActiveMobileRow(root) {
    var rows = getRows(root);
    var bestRow = null;
    var bestRatio = 0;

    rows.forEach(function (row) {
      var ratio = getRowVisibilityRatio(row, null);
      if (ratio >= 0.5 && ratio > bestRatio) {
        bestRatio = ratio;
        bestRow = row;
      }
    });

    return bestRow;
  }

  function pauseAllVideos(root, exceptVideo) {
    getVideos(root).forEach(function (video) {
      if (exceptVideo && video === exceptVideo) return;
      pauseVideo(video);
    });
  }

  function syncMobilePlayback(root) {
    if (!isMobileView()) return;

    var activeRow = getActiveMobileRow(root);
    var rows = getRows(root);

    rows.forEach(function (row) {
      var video = row.querySelector('.rabitat-product-features-hyde__video');
      if (!video) return;

      if (row === activeRow) {
        playVideo(video);
      } else {
        pauseVideo(video);
      }
    });

    if (activeRow) {
      preloadAdjacentVideo(root, activeRow);
    }
  }

  function bindMobilePlayback(root) {
    if (root.dataset.hydeVideoMobilePlaybackBound === 'true') return;
    root.dataset.hydeVideoMobilePlaybackBound = 'true';

    var syncTicking = false;

    function scheduleSync() {
      if (!isMobileView()) return;
      if (syncTicking) return;
      syncTicking = true;
      window.requestAnimationFrame(function () {
        syncTicking = false;
        syncMobilePlayback(root);
      });
    }

    if ('IntersectionObserver' in window) {
      var mobileObserver = new IntersectionObserver(
        function () {
          scheduleSync();
        },
        { root: null, threshold: [0, 0.25, 0.5, 0.75, 1], rootMargin: '0px' }
      );

      getRows(root).forEach(function (row) {
        mobileObserver.observe(row);
      });
    }

    window.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', function () {
      if (!isMobileView()) {
        pauseAllVideos(root);
        return;
      }
      scheduleSync();
    });
    scheduleSync();
  }

  function bindToggleButtons(root) {
    root.querySelectorAll('[data-hyde-video-toggle]').forEach(function (toggle) {
      if (toggle.dataset.hydeVideoToggleBound === 'true') return;
      toggle.dataset.hydeVideoToggleBound = 'true';

      toggle.addEventListener('click', function () {
        var media = toggle.closest('[data-hyde-video-media]');
        var video = media ? media.querySelector('.rabitat-product-features-hyde__video') : null;
        if (!video) return;

        if (video.paused) {
          pauseAllVideos(root, video);
          playVideo(video);
        } else {
          pauseVideo(video);
        }
      });
    });
  }

  function bindArrowScroll(carousel, root) {
    if (window.matchMedia('(max-width: 768px)').matches) return;

    var viewport = carousel.querySelector('[data-collection-viewport]');
    var track = carousel.querySelector('[data-collection-track]');
    var prevBtn = carousel.querySelector('[data-collection-prev]');
    var nextBtn = carousel.querySelector('[data-collection-next]');
    if (!viewport || !track) return;

    var itemSelector = carousel.getAttribute('data-carousel-item') || '[data-hyde-feature-row]';

    var scrollByItem = function (direction) {
      var item = track.querySelector(itemSelector);
      if (!item) return;
      var gap = parseFloat(getComputedStyle(track).gap || 0) || 0;
      viewport.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
    };

    var afterCarouselMove = function () {
      window.setTimeout(function () {
        preloadAdjacentVideo(root, getActiveRow(root));
      }, 320);
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByItem(-1);
        afterCarouselMove();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByItem(1);
        afterCarouselMove();
      });
    }

    if (viewport.dataset.hydeVideoScrollSyncBound === 'true') return;
    viewport.dataset.hydeVideoScrollSyncBound = 'true';

    var scrollTimer;
    viewport.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          preloadAdjacentVideo(root, getActiveRow(root));
        }, 120);
      },
      { passive: true }
    );
  }

  function initVideoScroll(root) {
    if (!root || root.dataset.hydeVideoScrollBound === 'true') return;
    root.dataset.hydeVideoScrollBound = 'true';

    getVideos(root).forEach(function (video) {
      prepareVideo(video);
      pauseVideo(video);
    });

    bindToggleButtons(root);
    bindArrowScroll(root, root);
    bindMobilePlayback(root);

    if ('IntersectionObserver' in window && !isMobileView()) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) return;
            var leavingVideo = entry.target.querySelector('.rabitat-product-features-hyde__video');
            if (leavingVideo) pauseVideo(leavingVideo);
          });
        },
        { threshold: [0, 0.25, 0.5], rootMargin: '0px 0px -8% 0px' }
      );

      getRows(root).forEach(function (row) {
        observer.observe(row);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hyde-video-scroll]').forEach(initVideoScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
